module.exports = __webpack_public_path__ + "static/media/hacker_medium.94531d09.png";